"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDirectLine;

var _botframeworkDirectlinejs = require("botframework-directlinejs");

function createDirectLine(_ref) {
  var botAgent = _ref.botAgent,
      conversationId = _ref.conversationId,
      domain = _ref.domain,
      fetch = _ref.fetch,
      pollingInterval = _ref.pollingInterval,
      secret = _ref.secret,
      streamUrl = _ref.streamUrl,
      token = _ref.token,
      watermark = _ref.watermark,
      webSocket = _ref.webSocket;
  return new _botframeworkDirectlinejs.DirectLine({
    botAgent: botAgent,
    conversationId: conversationId,
    domain: domain,
    fetch: fetch,
    pollingInterval: pollingInterval,
    secret: secret,
    streamUrl: streamUrl,
    token: token,
    watermark: watermark,
    webSocket: webSocket,
    createFormData: function createFormData(attachments) {
      var formData = new FormData();
      attachments.forEach(function (_ref2) {
        var contentType = _ref2.contentType,
            data = _ref2.data,
            filename = _ref2.filename,
            name = _ref2.name;
        formData.append(name, new Blob(data, {
          contentType: contentType
        }), filename);
      });
      return formData;
    }
  });
}